import QuestionnaireLoading from '@/app/components/loading-screen/components/questionnaire-loading/questionnaire-loading';
import { RiskProcessingStatus } from '@/repositories/risk-processing-status.repository';
import QuestionnaireError from './components/questionnaire-error/questionnaire-error';
import useLoadingScreenController from './loading-screen.controller';

export default function LoadingScreenPage() {
  const { status, isFirstAssessment, isCalculationComplete, initialCheckDone, resetStatus } =
    useLoadingScreenController();

  if (!initialCheckDone) {
    return <div className="h-screen w-screen bg-black" />;
  }

  switch (status) {
    case RiskProcessingStatus.error:
      return <QuestionnaireError resetStatus={resetStatus} />;
    default:
      return (
        <QuestionnaireLoading
          isFirstTimeLoadingResults={isFirstAssessment}
          isCalculationComplete={isCalculationComplete}
        />
      );
  }
}
